import { useCallback, useEffect, useState } from 'react';

import { getTags } from '../../../../api/services/Rides';

interface UseTagsHook {
  tags: string[];
  fetchTags: () => void;
  isFetching: boolean;
  hasFetched: boolean;
}

export const useTags = (): UseTagsHook => {
  const [tags, setTags] = useState<string[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const abortController = new AbortController();

  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  const fetchTags = useCallback(async () => {
    setIsFetching(true);
    const response = await getTags({}, abortController.signal);

    if (abortController.signal.aborted) {
      return;
    }
    if (response?.type === 'success') {
      setTags(response?.data.tags || []);
    }
    setIsFetching(false);
    setHasFetched(true);
  }, []);

  return { tags, isFetching, hasFetched, fetchTags };
};
